import { render, staticRenderFns } from "./ecosystem.vue?vue&type=template&id=05ee1368"
import script from "./ecosystem.vue?vue&type=script&lang=js"
export * from "./ecosystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports